/* Vistèra · script comuni a tutte le sezioni */
(function () {
  var designMode = window.Shopify && Shopify.designMode;

  // animazioni all'ingresso (nell'editor del tema mostra tutto subito)
  var io = !designMode && "IntersectionObserver" in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: .15 })
    : null;
  function initReveal(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll(".reveal:not(.in)"), function (el) {
      if (io) io.observe(el); else el.classList.add("in");
    });
  }
  initReveal(document);
  document.addEventListener("shopify:section:load", function (e) { initReveal(e.target); });

  // "Scegli la tua offerta": scorre al box acquisto se è nella pagina, altrimenti apre il prodotto
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".vst-scroll");
    if (!btn) return;
    var target = document.getElementById("acquista");
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth" }); }
    else if (btn.dataset.href) window.location.href = btn.dataset.href;
  });

  // carrello: + / − aggiornano la quantità e salvano subito
  Array.prototype.forEach.call(document.querySelectorAll(".qty"), function (q) {
    var input = q.querySelector("input");
    q.addEventListener("click", function (e) {
      var b = e.target.closest("button");
      if (!b) return;
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (b.dataset.step === "up" ? 1 : -1));
      input.form.submit();
    });
    input.addEventListener("change", function () { input.form.submit(); });
  });
})();
